import { Component, signal, WritableSignal, effect, runInInjectionContext, EnvironmentInjector, inject,OnInit } from '@angular/core';
import { DocumentReceptionService } from '../services/document-reception.service';
import { AssignedTaskService } from '../services/assigned-task.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@app/lib/services/dialog.service';
import { ETaskScreenName, IAssignedTask, IAssignedTaskEvent } from '../models/assigned-task.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BreadcrumbComponent } from '../../lib/components/breadcrumb/breadcrumb.component';
import { IBreadcrumb } from '@app/lib/models/breadcrumb.model';
import { MatTabLabel } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule } from '@angular/common';
import { FeeAssessmentService } from '../services/fee-assessment-service';
import { FeeAssessmentModel, FeeAssessmentResponse, FeeComponent, FeeComponentType, PaymentType } from '../models/fee-assessment.model';
import { IResponse } from '@app/lib/models/response.model';
import { MatTableDataSource } from '@angular/material/table';
import { TAny } from '@app/lib/models/common.type';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { MatProgressSpinnerModule, } from '@angular/material/progress-spinner';
import { LoginComponent } from '@app/login/login.component';
import { ILoginData } from '@app/lib/models/login.model';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { ECourtId } from '@app/dashboard/models/constant';

@Component({
  selector: 'app-record-fee-payment',
  standalone: true,
  imports: [BreadcrumbComponent, ReactiveFormsModule, FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule, MatAutocompleteModule, CommonModule, MatProgressSpinnerModule],
  templateUrl: './record-fee-payment.component.html',
  styleUrls: ['./record-fee-payment.component.scss'],
})
export class RecordFeePaymentComponent implements OnInit {
  // Signals for Breadcrumbs and Task
  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([]);
  public task: WritableSignal<IAssignedTask | null> = signal(null);
  feeAssessmentData: FeeComponent | null = null;
  public feecaseData: WritableSignal<FeeComponent | null> = signal(null);
  public feecaseData123: MatTableDataSource<FeeComponent> = new MatTableDataSource();
  public isEditing: WritableSignal<boolean> = signal(false); // Default is Read-Only
  public isLoading: WritableSignal<boolean> = signal(false); // Loader State
  public feeComponentTypes: FeeComponentType[] = [];
  public paymentTypes: PaymentType[] = [];
  private feeDataEffectUnsubscribe: any; // Store unsubscribe function
  private isSearchInProgress: boolean = false;
  public isDone: WritableSignal<boolean> = signal(false); // Default is Read-Only

  // Loading state



  public feeForm: FormGroup = new FormGroup({
    feeAmount: new FormControl({ value: '', disabled: true }, Validators.required),
    remarks: new FormControl({ value: '', disabled: true }),
    feeType: new FormControl({ value: '', disabled: true }, Validators.required),
    paymentType: new FormControl({ value: '', disabled: true }, Validators.required),

  });

  // Form Group
  public searchFormGrp: FormGroup = new FormGroup({
    caseNumber: new FormControl('', { nonNullable: true, validators: [Validators.required] }),

  });

  constructor(
    private service: FeeAssessmentService,
    private assignTaskService: AssignedTaskService,
    private dialog: MatDialog,
    private dialogService: DialogService,
  ) {
    console.log('🚀 FeeAssessmentComponent Constructor Loaded');

    // ✅ Ensure `effect()` is inside injection context
    const injector = inject(EnvironmentInjector);
    runInInjectionContext(injector, () => {
      effect(() => {
        const feeData = this.feecaseData();
        this.feecaseData123.data = feeData ? [feeData] : [];
      });
    });

    // ✅ Task Subscription
    this.assignTaskService.assignTask$
      .pipe(
        takeUntilDestroyed(),
        filter((event) => event.name === ETaskScreenName.RECORDFEEPAYMENT)
      )
      .subscribe({
        next: (event: IAssignedTaskEvent) => {
          console.log('🎯 Task Assigned:', event.task);
          if (event.task?.docId) {
            console.log('📌 Task has docId:', event.task.docId);
            this.searchHandler(event.task.docId, false);
          }
        },
      });
  }


 ngOnInit(): void {
      this.getCourtNameData();
  }
  // Search handler for form submission
  searchHandler(docId?: string, istask: boolean = true): void {
    this.isEditing.set(false);
    const feeData = this.feecaseData();
    this.feeForm.get('feeAmount')?.disable();
    this.feeForm.get('feeType')?.disable();
    this.feeForm.get('paymentType')?.disable();
    this.feeForm.get('remarks')?.disable();
    if (this.isSearchInProgress) return; // ✅ Prevent duplicate API calls
    this.isSearchInProgress = true;

    if (!docId && this.searchFormGrp.invalid) return;

    const searchValue = docId || this.searchFormGrp.get('caseNumber')?.value;
    console.log(`🔍 Sending API Request with docId: ${searchValue}`);
    this.isLoading.set(true);
    if (istask) {
      this.isDone.set(true);
    } else {
      this.isDone.set(false);
    }

    this.service.getRecordfeeComponent({ "docId": searchValue }).subscribe({
      next: (response: IResponse<FeeComponent[]>) => {
        console.log("✅ API Response Received:", response);
        if (response?.data?.length > 0) {
          const feeData = response.data[0];
          this.feecaseData.set(feeData);
          this.searchFormGrp.patchValue({ caseNumber: feeData.docId || '' });
          this.fetchComponentTypes(() => {
            this.fetchPaymentTypes(() => {
              this.updateFormValues();
            });
          });

        } else {
          this.dialogService.openDialog1({
            data: {
              title: "Info",
              message: "No Privilege to access the data (or) No Data Exists",
              icon: 'info', // ✅ Default icon if not provided
            }, disableClose: true,           // Prevents closing on outside click or ESC
            hasBackdrop: true,            // Shows backdrop to block interaction
            backdropClass: 'dialog-backdrop', // Optional: custom styling
          });

          this.feecaseData.set(null);
        }
        this.isLoading.set(false);
        this.isSearchInProgress = false;
      },
      error: () => {
        this.feecaseData.set(null);
        this.isLoading.set(false);
        this.isSearchInProgress = false;
        this.dialogService.openDialog1({
          data: {
            title: "Info",
            message: "No Privilege to access the data (or) No Data Exists",
            icon: 'info', // Default icon if not provided
          }, disableClose: true,           // Prevents closing on outside click or ESC
          hasBackdrop: true,            // Shows backdrop to block interaction
          backdropClass: 'dialog-backdrop', // Optional: custom styling
        });

      },
    });
  }

  toggleEdit(): void {


    this.isEditing.set(!this.isEditing());

    // Enable or disable fields based on the toggle
    if (this.isEditing()) {
      this.feeForm.get('feeAmount')?.enable();
      this.feeForm.get('feeType')?.enable();
      this.feeForm.get('paymentType')?.enable();
      this.feeForm.get('remarks')?.enable();

      const feeTypeControl = this.feeForm.get('feeType');
      const paymentTypeControl = this.feeForm.get('paymentType');
      if (!feeTypeControl?.value) {
        this.feeForm.patchValue({ 'feeType': this.feeComponentTypes[0] })
      }
      if (!paymentTypeControl?.value) {
        this.feeForm.patchValue({ 'paymentType': this.paymentTypes[0] })
      }
    } else {
      const feeData = this.feecaseData();
      this.feeForm.get('feeAmount')?.disable();
      this.feeForm.get('feeType')?.disable();
      this.feeForm.get('paymentType')?.disable();
      this.feeForm.get('remarks')?.disable();
      if (feeData) {
        const initialFeeType = this.feeComponentTypes.find(x => x.id === feeData?.feeCompTypesId) || null;
        const initialPaymentType = this.paymentTypes.find(x => x.id === feeData?.paymentTypesId) || null;
        this.feeForm.patchValue({
          feeAmount: feeData.feePaid || 0,
          remarks: feeData.remarks || '',
          paymentType: initialPaymentType,
          feeType: initialFeeType
        });
      }


    }
  }
  resetHandler(): void {
    this.searchFormGrp.reset();
    this.feecaseData.set(null);
    this.feecaseData123.data = [];
    this.isEditing.set(false);// ✅ Reset table data safely
  }



  nonZeroValidator(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    if (value !== null && value !== undefined && value.toString().startsWith('0')) {
      return { nonZero: true };
    }
    return null;
  }
  fetchComponentTypes(callback?: () => void): void {
    this.service.getfeeComponentType().subscribe({
      next: (response) => {
        this.feeComponentTypes = response.success || [];
        if (callback) callback();
      },
      error: () => {
        console.error("❌ Error fetching Fee Component Types");
        this.feeComponentTypes = [];
        this.dialogService.openDialog1({
          data: {
            title: "Info",
            message: "Failed to load fee component types.",
            icon: 'info', // ✅ Default icon if not provided
          }, disableClose: true,           // Prevents closing on outside click or ESC
          hasBackdrop: true,            // Shows backdrop to block interaction
          backdropClass: 'dialog-backdrop', // Optional: custom styling
        });

      },
    });
  }

  fetchPaymentTypes(callback?: () => void): void {
    this.service.getPaymentTypes().subscribe({
      next: (response) => {
        this.paymentTypes = response.success || [];
        if (callback) callback();
      },
      error: () => {
        console.error("❌ Error fetching Payment Types");
        this.paymentTypes = [];
        this.dialogService.openDialog1({
          data: {
            title: "Info",
            message: "Failed to load payment types.",
            icon: 'info', // ✅ Default icon if not provided
          }, disableClose: true,           // Prevents closing on outside click or ESC
          hasBackdrop: true,            // Shows backdrop to block interaction
          backdropClass: 'dialog-backdrop', // Optional: custom styling
        });

      },
    });
  }



  private updateFormValues(): void {
    const feeData = this.feecaseData();

    if (feeData) {
      const initialFeeType = this.feeComponentTypes.find(x => x.id === feeData?.feeCompTypesId) || null;
      const initialPaymentType = this.paymentTypes.find(x => x.id === feeData?.paymentTypesId) || null;
      this.feeForm.patchValue({
        feeAmount: feeData.feePaid || 0,
        remarks: feeData.remarks || '',
        paymentType: initialPaymentType,
        feeType: initialFeeType
      });
    } else {
      this.feeForm.reset();
    }
  }
  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      const userData2 = userData ? JSON.parse(userData) : null;
        const courtIdData = userData2.courtId;
            if (courtIdData && courtIdData === ECourtId.SC_ID) {
              this.breadcrumbs.set([ { label: 'Appeal' },
    { label: 'Fee Payment' },])
            } else{
                 this.breadcrumbs.set([ { label: 'Case' },
    { label: 'Fee Payment' },])
            }
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      return null
    }
  }
  public _onsave() { // Reset the attachmentsData signal
    if (!this.feeForm.valid) {
      return; // Stop execution if form is invalid
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: "Do you want to Save?",
      }, disableClose: true,           // Prevents closing on outside click or ESC
      hasBackdrop: true,            // Shows backdrop to block interaction
      backdropClass: 'dialog-backdrop', // Optional: custom styling
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const feeData = this.feecaseData();

        this.isLoading.set(true);
        const reqBody: TAny = {
          feeComponentId: feeData?.feeComponentId ? feeData.feeComponentId.toString() : '',  // Ensure safe toString()
          docId: feeData?.docId ? feeData.docId.toString() : '',
          feeCompTypesId: this.feeForm.get("feeType")?.value?.id || '',
          feeCompTypesName: this.feeForm.get("feeType")?.value?.name || '',
          feePaid: this.feeForm.get("feeAmount")?.value ? this.feeForm.get("feeAmount")?.value.toString() : '',
          paymentTypesId: this.feeForm.get("paymentType")?.value?.id || '',
          remarks: this.feeForm.get("remarks")?.value || '',
          courtType: this.getCourtNameData()?.roleDTOList?.[0]?.rcaCode ? this.getCourtNameData()?.roleDTOList[0].rcaCode.toString() : '',
          docTypeId: feeData?.docTypeId ? feeData.docTypeId.toString() : '',
          govtPartyFlag: feeData?.govtPartyFlag.toString() || '',
          transType: "U",
          docType: feeData?.docType || ''
        };


        this.service.feePaymentSave(reqBody).subscribe({
          next: (res: IResponse<TAny> | null) => {
            if (res?.message && res.message != null) {
              console.log(res.message) // Set the entire list of case documents
              if (res.success) {
                this.dialogService.openDialog1({
                  data: {
                    title: "Success",
                    message: res.message,
                    icon: 'check_small', // ✅ Default icon if not provided
                  }, disableClose: true,           // Prevents closing on outside click or ESC
                  hasBackdrop: true,            // Shows backdrop to block interaction
                  backdropClass: 'dialog-backdrop', // Optional: custom styling

                })
                this.searchHandler(this.feecaseData()?.docId, true);
              } else {
                this.dialogService.openDialog1({
                  data: {
                    title: "Information",
                    message: res.message,
                    icon: 'info', // ✅ Default icon if not provided
                  }, disableClose: true,           // Prevents closing on outside click or ESC
                  hasBackdrop: true,            // Shows backdrop to block interaction
                  backdropClass: 'dialog-backdrop', // Optional: custom styling
                })
              };
            }

          },
          error: (err) => {
            console.error('Error fetching case data:', err);
            this.isLoading.set(false);
          },
        });
        this.cancelEdit();
        this.isLoading.set(false);
      }


    });
  }
  cancelEdit(): void {
    this.isEditing.set(false); // Disable edit mode

    this.feeForm.patchValue({
      feeAmount: this.feecaseData()?.feePaid || 0,
      remarks: this.feecaseData()?.remarks || '',
      paymentType: this.feecaseData()?.paymentTypesId,
      feeType: this.feecaseData()?.feeCompTypesId
    });
    this.feeForm.get('feeAmount')?.disable();
    this.feeForm.get('feeType')?.disable();
    this.feeForm.get('paymentType')?.disable();
    this.feeForm.get('remarks')?.disable();

  }
  onPrint(): void {
    if (this.feecaseData() != null) {
      this.isLoading.set(true);
      const reqData: FeeComponent | TAny = this.feecaseData();


      console.log(`ReqData : ${reqData}`);
      this.service.feePaymentPrint(reqData).subscribe({
        next: (blob) => {
          if (blob) {
            console.log('✅ Print file received successfully');

            // Fix: Correctly open PDF in a new tab
            const blobUrl = window.URL.createObjectURL(blob);
            const newTab = window.open(blobUrl, '_blank');

            if (!newTab) {
              console.warn("⚠️ Popup blocked. Please allow pop-ups for this site.");
              this.dialogService.openDialog1({
                data: {
                  title: "Warning",
                  message: "Popup blocked! Please allow pop-ups for this site.",
                  icon: 'warning',
                }, disableClose: true,           // Prevents closing on outside click or ESC
                hasBackdrop: true,            // Shows backdrop to block interaction
                backdropClass: 'dialog-backdrop', // Optional: custom styling
              });
            }

            // Fix: Revoke the object URL after some time to free memory
            setTimeout(() => window.URL.revokeObjectURL(blobUrl), 5000);
          } else {
            console.error("❌ Received empty response while printing.");
            this.dialogService.openDialog1({
              data: {
                title: "Error",
                message: "Failed to generate print file. Received empty response.",
                icon: 'error',
              }, disableClose: true,           // Prevents closing on outside click or ESC
              hasBackdrop: true,            // Shows backdrop to block interaction
              backdropClass: 'dialog-backdrop', // Optional: custom styling
            });
          }
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error("❌ Error while printing:", err);
          this.dialogService.openDialog1({
            data: {
              title: "Information",
              message: "Failed to generate print file.",
              icon: "info",
            }, disableClose: true,           // Prevents closing on outside click or ESC
            hasBackdrop: true,            // Shows backdrop to block interaction
            backdropClass: 'dialog-backdrop', // Optional: custom styling
          });
          this.isLoading.set(false);
        },
      });
    }
  }
}
